export enum DeploymentOperationType {
  add,
  remove,
  update
}
